var map = {
	"./background-success": 85,
	"./background-success.webp": 85,
	"./dummy-car-item": 86,
	"./dummy-car-item.jpg": 86,
	"./dummy-car-show-carousel": 87,
	"./dummy-car-show-carousel.jpg": 87,
	"./dummy-ford": 88,
	"./dummy-ford.png": 88,
	"./dummy-main-carousel": 89,
	"./dummy-main-carousel.png": 89,
	"./dummy-thumbnail1": 90,
	"./dummy-thumbnail1.jpg": 90,
	"./dummy-thumbnail2": 91,
	"./dummy-thumbnail2.jpg": 91,
	"./hero-img": 92,
	"./hero-img.png": 92,
	"./logo-ford": 93,
	"./logo-ford-naked": 94,
	"./logo-ford-naked.svg": 94,
	"./logo-ford.svg": 93
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 194;